<template>
    <div id="fixedHeader" class="fixed-header">
        <statusBar></statusBar>
        <div v-if="isShowDownAppNav && false" class="downApp">
            <div class="icon-close" @click="onCloseDownAppNav">
                <i class="iconfont icon-s-cuowu-guanbi"></i>
            </div>
            <div class="tips">{{ domainKey }} {{ $t("footer.ApplicableTo") }} {{ sysPlatform == 'Windows' ? 'Windows' :
                            (sysPlatform == 'ios' ? 'IOS' : 'Android') }}</div>
            <!-- <div class="tips">
                <span>{{ $t("home.DownloadTips") }}</span>
                <span class="money">{{ CurrencyType }}100</span>
            </div> -->
            <div class="btn" @click="onShowDownAppPopup">
                <i class="iconfont icon-shouji"></i>
                <span>{{ $t("home.Download") }}</span>
            </div>
        </div>
        <div class="pages-header">
            <div class="area_left">
                <img class="icon_toggle" src="@/assets/header/icon_toggle.png" alt="" @click="toggleSideBar">
                <!-- <i class="icon_toggle iconfont icon-caidanshouqi" :class="{'sidebarOpened': sidebar.opened}" @click="toggleSideBar"></i> -->
                <!-- <div v-if="device !== 'mobile'" class="down_box" @click="onShowDownAppPopup">
                    <div class="down_img">
                        <img src="@/assets/header/icon_window.png" alt="" />
                    </div>
                    <div class="down_info">
                        <div>{{ $t("downApp.ApplicableWindows") }}</div>
                        <div>{{ $t("downApp.ApplicableWindowsTips") }}</div>
                    </div>
                </div> -->
            </div>
            <div v-if="device !== 'mobile'" class="search_btn" @click.stop="toSearch" >
                <i class="iconfont icon-sousuo"></i>
                <div class="txt"> {{ $t("home.SearchGames") }}</div>
            </div>
            <div v-if="device !== 'mobile' && isShowSport" class="sportsBox">
                <div class="selectBtn" @click.stop="onPageRefresh" :class="{'sportSelect': !isIntoSport}">
                    <img class="iconm" src="@/assets/common/kaipai.png" />
                    <span>{{ $t("sports.home") }}</span>
                    <div class="lines" v-if="!isIntoSport"></div>
                </div>
                <div class="selectBtn" @click.stop="toSports" :class="{'sportSelect': isIntoSport}">
                    <img class="iconm" src="@/assets/common/zuqiu.png" />
                    <span>{{ $t("sports.title") }}</span>
                    <div class="lines" v-if="isIntoSport"></div>
                </div>
            </div>
            <div class="icon_logo" :class="{'mobile_logo': device == 'mobile'}">
                <img v-if="device == 'mobile'" class="logo" :src="logoUrl2" @click.stop="onPageRefresh" />
                <img v-else class="logo" :src="logoUrl" @click.stop="onPageRefresh" />
            </div>
            <div class="user_action">
                <div></div>
                <div>
                    <div v-if="isLogin && device === 'mobile'" class="user_info">
                        <div class="iconfont icon-shuaxin" :class="{'turning':isRefreshingMoney}" @click.stop="getUserInfo"></div>
                        <div class="user_money"  @click.stop="$store.dispatch('user/setIsShowBalancePopup', true)">
                            {{ CurrencyType }}{{ allBalance }}
                        </div>
                        <div class="deposit" @click.stop="toDeposit">+</div>
                    </div>
                    <div v-if="isLogin && device !== 'mobile'" class="user_info_pc" @click.stop="toMy">
                        <img class="u_avatar" src="@/assets/person/avatar.png" />
                        <div class="u-info">
                            <div>Hi, {{ userPhone }}</div>
                            <div>ID:{{ userInfo.id }}</div>
                        </div>
                        <img class="u-arrow" src="@/assets/header/icon_arrow.png" />
                    </div>
                    <div v-if="!isLogin" class="user_login">
                        <div class="sign_up" @click="toLogin(1)">{{ $t("login.SignUp") }}</div>
                        <div class="login" @click="toLogin(2)">{{ $t("login.SignIn") }}</div>
                    </div>
                    <div v-if="isLogin" class="Notification" @click.stop="toNotification">
                        <i class="iconfont icon-xiangling"></i>
                        <div v-if="noticeNumber" class="matterNumber">{{ noticeNumber }}</div>
                    </div>
                </div>
            </div>
        </div>
        <logoutPopup ref="logoutPopup"></logoutPopup>
        <!-- <BonusTransferPopup ref="BonusTransferPopup" @confirm="isLogin && getUserInfo()"></BonusTransferPopup> -->
    </div>
</template>

<script>
import { domainKey } from '@/common/http'
import statusBar from '@/components/statusBar'
import logoutPopup from '@/components/logoutPopup'
import { mapState } from 'vuex'
import { getUserInfo } from '@/api/user'
import { isPWA, getPlatform } from '@/utils'
import { Toast } from 'vant'
let savedPwaPrompt888 = null
// import BonusTransferPopup from '@/components/BonusTransferPopup'
export default {
    name: 'Header',
    components: { statusBar, logoutPopup },
    data() {
        return {
            sysPlatform: getPlatform(),
            domainKey,
            pathAct: '',
            isRefreshingMoney: false
        }
    },
    computed: {
        isIntoSport() {
            return this.$store.state.system.isShowSports
        },
        isShowSport() {
            if (this.$store.getters.userInfo.memberType === 'virtually') return false
            const msg = this.$store.state.system.betSportMsg
            return msg?.brandId !== null && msg?.gameInfoId !== null
        },
        ...mapState({
            device: state => state.app.device,
            sidebar: state => state.app.sidebar
        }),
        isLogin() {
            return !!this.$store.getters.token
        },
        logoUrl() {
            return this.$store.getters.sysConfig?.homeLogoUrl
        },
        logoUrl2() {
            return this.$store.getters.sysConfig?.homeImageUrl
        },
        userInfo() {
            return this.$store.getters.userInfo
        },
        userPhone() {
            const phone = this.userInfo && this.userInfo.phone
            return phone ? this.maskNumber(phone) : ''
        },
        isShowDownAppNav() {
            const isShowDownAppNav = Number(this.$store.state.system.isShowDownAppNav)
            // let downType = this.$store.state.vuex_sysConfig && this.$store.state.vuex_sysConfig.downType || 'apk'
            return isShowDownAppNav === 1 && (!isPWA()) && getPlatform() !== 'android' && getPlatform() !== 'Android' && getPlatform() !== 'ios'
        },
        noticeNumber() {
            return this.$store.getters.noticeNumber
        }
    },
    created() {
        this.pathAct = this.$route.name
        // if (this.isLogin) getUserInfo()
    },
    mounted() {
        try {
            this.$nextTick(() => {
                window.addEventListener('beforeinstallprompt', function (e) {
                    // 阻止默认提示弹出
                    e.preventDefault()
                    // 把事件存起来
                    savedPwaPrompt888 = e
                })
            })
        } catch {
            console.log('error-pwa-不支持？不显示？')
        }
        if (this.$route.path.indexOf('/Sports') !== -1) {
            this.$store.dispatch('system/setIsShowSport', true)
        }
    },
    methods: {
        getUserInfo() {
            this.isRefreshingMoney = true
            getUserInfo().finally(() => {
                this.isRefreshingMoney = false
            })
        },
        onMenuItem(act) {
            if (this.pathAct === act) {
                Toast(this.$t('lang.CurrentlyPage'))
                return
            }
            this.pathAct = act
            this.onNavTo({ url: act, type: 'post' })
        },
        toggleSideBar() {
            this.$store.dispatch('app/toggleSideBar')
        },
        toLogin(type) {
            this.$store.dispatch('user/changeLoginType', type)
            this.$store.dispatch('user/setIsShowLoginPopup', true)
        },
        handleLogout() {
            this.$refs.logoutPopup.open()
        },
        toMy() {
            this.$store.dispatch('user/setIsShowMyPopup', true)
        },
        // onShowDownAppPopup() {
        //     this.$store.dispatch('user/setIsShowDownAppPopup', true)
        // },
        onCloseDownAppNav() {
            this.$store.dispatch('system/setIsShowDownAppNav', 2)
        },
        onShowDownAppPopup() {
            if (this.sysPlatform === 'WebAndroidGame') {
                this.$store.dispatch('user/setIsShowDownAppPopup', true)
            }
            if (this.sysPlatform === 'Windows') {
                if ('serviceWorker' in navigator) {
                    try {
                        savedPwaPrompt888.prompt()
                        savedPwaPrompt888.userChoice.then(choiceResult => {
                            if (choiceResult.outcome === 'accepted') {
                                // this.isShowTipsPopup = true
                                // uni.reLaunch({
                                // 	url: '/pages/index/index'
                                // })
                            } else {
                                console.log('User declined PWA install prompt')
                            }
                        })
                    } catch (e) {
                        console.log(e, 'error-pwa-不支持？不显示？')
                        // pwaIconShow.value = false
                    }
                } else {
                    console.log('Current device does not support this feature')
                }
            }
            // if (this.sysPlatform === 'ios') {
            //     this.$refs.pwaIosPopup.open()
            // }
        },
        toSearch() {
            this.$store.dispatch('user/setIsShowSearchPopup', true)
        },
        maskNumber(phoneNumber) {
            const str = phoneNumber.toString()
            if (str.length <= 4) {
                return str
            }
            const firstTwo = str.slice(0, 2)
            const lastTwo = str.slice(-2)
            return `${firstTwo}***${lastTwo}`
        },
        toSports() {
            if (this.$route.path.indexOf('/Sports') !== -1) {
                return
            }
            this.$store.dispatch('system/setIsShowSport', true)
            this.onNavTo({ url: 'Sports' })
        },
        toDeposit() {
            if (this.$route.path.indexOf('/wallet') !== -1) {
                return
            }
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toNotification() {
            if (this.$route.path.indexOf('/notification') !== -1) {
                return
            }
            const params = { type: 1 }
            this.onNavTo({ url: '/notification', type: 'get', params })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';
.fixed-header {
    width: 100%;
    position: relative;
    z-index: 1000;
    // box-shadow: 0 4px 20px #0006;

    .downApp {
        background: linear-gradient(90deg, #f90, #ec0039);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 .2rem;
        box-sizing: border-box;
        height: .9rem;
        position: relative;

        &>div.icon-close {
            position: absolute;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, .3);
            border-bottom-right-radius: 100%;
            width: .53rem;
            height: .45rem;
            padding-right: .08rem;
            padding-bottom: .1rem;
            box-sizing: border-box;

            &>i {
                font-size: .2rem;
                font-weight: bold;
                color: rgba(255, 255, 255, .8);
            }
        }

        &>div.tips {
            padding-left: .28rem;
            color: #fff;
            font-size: .28rem;

            .money {
                color: #f3df00;
                font-size: .3rem;
                font-weight: 700;
            }
        }

        &>div.btn {
            background: #fff;
            color: #ec0048;
            font-size: .18rem;
            line-height: .5rem;
            padding: .048rem .16rem;
            padding-right: .2rem;
            border-radius: .2rem;
            display: flex;
            align-items: center;

            &>i {
                margin-right: .08rem;
            }
        }
    }

    .pages-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        height: 1.2rem;
        box-sizing: border-box;
        position: relative;
        padding-left: 300px;

        .sportsBox {
            position: absolute;
            left: 270px;
            z-index: 7;
            display: flex;
            height: 80%;
            cursor: pointer;

            .selectBtn {
                padding: 0 22px;
                height: 100%;
                line-height: 40px;
                font-size: 23px;
                position: relative;
                font-weight: bold;
                display: flex;
                align-items: center;
            }

            .iconm {
                width: auto;
                height: 60%;
                margin-right: 20px;
            }

            .lines {
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 60%;
                height: 6px;
                border-radius: 6px;
                background: #ffce2e;
            }
        }

        .sportSelect {
            border: 2px solid rgba($border-color, .3);
            border-radius: 8px;
            box-shadow:
                inset 0 1px 0 rgba(#000, .08),
                0 0 .16rem rgba(#000, .3),
                0 .04rem .1rem rgba(#000, .16);
        }

        .area_left{
            position: absolute;
            left: .34rem;
            display: flex;
            align-items: center;
            z-index: 8;

            .icon_toggle{
                color: rgb(174,194,228);
                font-size: .48rem;
                margin-right: .16rem;
                transition: all .3s;
                width: .52rem;
                height: .52rem;
                vertical-align: middle;
                border-radius: .1rem;
                cursor: pointer;

                &.sidebarOpened{
                    transform: rotate(180deg);
                }
            }

            .down_box {
                padding: 4px 6px;
                border-radius: 8px;
                display: flex;
                align-items: center;
                cursor: pointer;
                width: 212px;
                text-align: left;

                .down_img{
                    width: .6rem;
                    height: .6rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 10px;
                }

                img {
                    width: .4rem;
                    height: .4rem;
                    vertical-align: middle;
                }

                .down_info {
                    font-size: 13px;
                    flex: 1;
                    margin-left: 0.12rem;
                    font-weight: bold;
                    line-height: 18px;

                    &> div:last-child {
                        line-height: 15px;
                        font-size: 12px;
                    }
                }
            }
        }

        .search_btn{
            width: 150px;
            height: 44px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            cursor: pointer;
            margin-left: 20px;
            position: absolute;
            left: 70px;
            z-index: 7;

            .txt {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                // height: 44px;
                // line-height: 42px;
                font-size: 15px;
            }

            .iconfont {
                font-weight: bold;
                height: 44px;
                width: 38px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        &>div.icon_logo {
            position: absolute;
            height: 100%;
            left: calc(50% + 70px);
            transform: translateX(-50%);
            top: 0;
            z-index: 3;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            padding: 0 60px;

            .logo {
                height: 1.15rem;
                width: auto;
                will-change: auto !important;
                cursor: pointer;
            }

            &.mobile_logo{
                width: auto !important;
                left: .76rem !important;
                transform: translate(0, -50%) !important;
                background: transparent;
                top: 50% !important;
                padding: 0;
                .logo {
                    height: .84rem !important;
                    filter: drop-shadow(0 0 .08rem rgba($font-theme-color, .28));
                }
            }
        }

        .user_action {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            z-index: 2;
            margin: 0 auto;
            // max-width: 1414px;
            min-width: 720px;
            padding-left: 32px;
            padding-right: 32px;
            width: 100%;

            &>div:last-child {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }

            .user_info {
                display: flex;
                align-items: center;
                justify-content: space-between;
                min-width: 3.15rem;
                height: .76rem;
                padding: .06rem .08rem;
                border-radius: .16rem;
                overflow: hidden;
                box-sizing: border-box;

                .icon-shuaxin {
                    font-size: .3rem;
                    // width: .45rem;
                    margin-right: .08rem;
                    text-align: center;

                    &.turning {
                        animation: rotateAni 0.2s linear infinite;
                    }

                    @keyframes rotateAni {
                        0% {
                            transform: rotate(0deg);
                        }

                        100% {
                            transform: rotate(-360deg);
                        }
                    }
                }

                .user_account,
                .user_money {
                    padding: 0 .08rem;
                    border-radius: .2rem;
                    margin-top: 0;
                    font-size: .26rem;
                    font-weight: 700;
                    letter-spacing: .01rem;
                    white-space: nowrap;
                    cursor: pointer;
                }

                .user_account {
                    color: $font-sub-color;
                }

                .deposit {
                    height: .6rem;
                    border-radius: .17rem;
                    line-height: .6rem;
                    font-size: .5rem;
                    margin-left: .08rem;
                    cursor: pointer;
                    width: .66rem;
                    box-sizing: border-box;
                    position: relative;
                    overflow: hidden;

                    &:after {
                        content: "";
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        background-image: linear-gradient(90deg, transparent, rgba(255, 255, 255, .5), transparent);
                        background-repeat: no-repeat;
                        animation: bgmove-1badf8a4 linear 2.5s infinite;
                    }

                    @keyframes bgmove-1badf8a4 {
                        0% {
                            background-position: -200px 0
                        }

                        to {
                            background-position: 400px 0
                        }
                    }
                }
            }

            .user_info_pc{
                position: relative;
                cursor: pointer;
                border-radius: 30px;
                padding: 4px 7px 4px 4px;
                height: 48px;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                gap: 0;

                .u_avatar{
                    border-radius: 25px;
                    margin-right: 8px;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 40px;
                    border-radius: 25px;
                    object-fit: contain;
                    vertical-align: middle;
                }
                .u-info{
                    line-height: 1.02;
                    font-size: 16px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    min-width: 0;

                    & > div:first-child{
                        font-weight: 700;
                        white-space: nowrap;
                    }
                    & > div:last-child{
                        font-size: 13px;
                        margin-top: 2px;
                        white-space: nowrap;
                    }
                }
                .u-arrow{
                    transform: rotate(-90deg);
                    width: 12px;
                    margin: 0 3px 0 6px;
                    border-style: none;
                    height: auto;
                    flex: none;
                }
            }

            .Notification {
                width: 46px;
                height: 46px;
                border-radius: 23px;
                margin: 0 0 0 7px;
                cursor: pointer;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;

                &:hover {
                    filter: brightness(1.05);
                }

                &>i {
                    font-size: .36rem;
                }

                .matterNumber{
                    position: absolute;
                    height: .36rem;
                    width: .36rem;
                    border-radius: 50px;
                    background: $font-error-color;
                    font-size: .26rem;
                    color: #fff;
                    top:-.1rem;
                    right: -.1rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }

            .user_login {
                font-size: .26rem;
                height: .7rem;
                line-height: .7rem;
                display: flex;
                align-items: center;

                .login {
                    cursor: pointer;
                    text-align: center;
                    padding: 0 .18rem;
                    border-radius: .1rem;
                    margin-right: .02rem;
                    }

                .sign_up {
                    cursor: pointer;
                    text-align: center;
                    border-radius: .15rem;
                    padding: 0 .18rem;
                    margin-right: .12rem;
                    font-weight: bold;

                }
            }
        }
    }
}

html[data-device-nodesktop="1"] {
    .fixed-header {
        z-index: 1000;

        .downApp {
            display: none;
        }
    }
}
html[data-device-nodesktop="0"] {
    .fixed-header {
        .pages-header {
            min-height: 1.04rem;
            padding: .12rem .2rem;
            padding-left: 4.48rem;
            gap: .14rem;
            box-sizing: border-box;
        }

        .pages-header .area_left {
            left: .12rem;
            gap: .1rem;
            max-width: 4.08rem;
        }

        .pages-header .area_left .icon_toggle {
            width: .44rem;
            height: .44rem;
            padding: .07rem;
            flex: none;
        }

        .pages-header .area_left .down_box {
            height: .58rem;
            width: 3.62rem;
            padding: .05rem .16rem .05rem .1rem;
            border-radius: .14rem;
            gap: .08rem;
            box-sizing: border-box;
        }

        .pages-header .area_left .down_box .down_img {
            width: .42rem;
            height: .42rem;
            border-radius: .12rem;
            flex: none;
        }

        .pages-header .area_left .down_box .down_img img {
            width: .24rem;
            height: .24rem;
        }

        .pages-header .area_left .down_box .down_info {
            line-height: .96;
            min-width: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .pages-header .area_left .down_box .down_info > div:first-child {
            font-size: .085rem;
            font-weight: 700;
            line-height: .96;
            letter-spacing: .002rem;
        }

        .pages-header .area_left .down_box .down_info > div:last-child {
            margin-top: .015rem;
            font-size: .065rem;
            line-height: .96;
            letter-spacing: .001rem;
        }

        .pages-header .search_btn {
            width: 2.18rem;
            height: .62rem;
            border-radius: .14rem;
            padding: 0 .18rem;
            margin-left: 0;
            flex: none;
            justify-content: flex-start;
            gap: .1rem;
            box-sizing: border-box;
        }

        .pages-header .search_btn .iconfont {
            font-size: .22rem;
            flex: none;
        }

        .pages-header .search_btn .txt {
            font-size: .14rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .pages-header > div.icon_logo {
            width: 3.9rem;
            height: .74rem;
            left: 50%;
            transform: translateX(-50%);
            top: .04rem;
            border-radius: 0;
            overflow: hidden;
        }

        .pages-header > div.icon_logo .logo {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            filter: drop-shadow(0 2px 4px rgba($bg-shell-color, .35));
        }

        .pages-header .user_action {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            min-width: 0;
        }

        .pages-header .user_action > div:last-child {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: .1rem;
            min-width: 0;
        }

        .pages-header .user_info_pc {
            height: .62rem;
            padding: .04rem .08rem .04rem .05rem;
            border-radius: .14rem;
            box-sizing: border-box;
        }

        .pages-header .user_info_pc .u_avatar {
            width: .5rem;
            min-width: .5rem;
            height: .5rem;
            margin-right: .08rem;
            border-radius: 50%;
        }

        .pages-header .user_info_pc .u-info {
            font-size: .14rem;
            white-space: nowrap;
            min-width: 1.16rem;
            justify-content: center;
        }

        .pages-header .user_info_pc .u-info > div:last-child {
            margin-top: .03rem;
            font-size: .1rem;
        }

        .pages-header .user_info_pc .u-arrow {
            width: .12rem;
            margin: 0 .03rem 0 .05rem;
            opacity: .95;
            filter: brightness(2.4) saturate(.15);
        }

        .pages-header .Notification {
            width: .58rem;
            height: .58rem;
            min-width: .58rem;
            border-radius: 50%;
            margin: 0;
        }

        .pages-header .Notification > i {
            font-size: .22rem;
        }

        .pages-header .user_login {
            height: .62rem;
            line-height: .62rem;
            gap: .1rem;
        }

        .pages-header .user_login .sign_up,
        .pages-header .user_login .login {
            height: .62rem;
            line-height: .62rem;
            min-width: 1.34rem;
            padding: 0 .2rem;
            border-radius: .14rem;
            font-size: .23rem;
            font-weight: 700;
            margin-right: 0;
            box-sizing: border-box;
        }

        .pages-header .user_login .login {
            min-width: 1.48rem;
        }
    }
}

.fixed-header {
    background:
        radial-gradient(circle at 12% 0, rgba($font-theme-color, .18) 0, rgba($font-theme-color, 0) 22%),
        radial-gradient(circle at 88% 0, rgba($border-active-color, .12) 0, rgba($border-active-color, 0) 24%),
        $bg-header-shell-color;
    border-bottom: 1px solid $border-soft-color;
    box-shadow: inset 0 1px 0 rgba($font-label-color, .1);
}

.pages-header {
    background: transparent;
}

.pages-header .area_left .icon_toggle {
    background:
        linear-gradient(180deg, rgba($font-label-color, .18) 0%, rgba($font-label-color, .04) 22%, rgba($font-label-color, 0) 23%),
        $bg-btn-bot-color;
    box-shadow: inset 0 1px 0 rgba($font-title-color, .28), 0 .06rem .12rem rgba($bg-shell-color, .22);
}

.pages-header .area_left .down_box {
    background:
        radial-gradient(circle at 16% 0, rgba($font-theme-color, .2) 0, rgba($font-theme-color, 0) 28%),
        linear-gradient(180deg, rgba($font-label-color, .08) 0%, rgba($font-label-color, 0) .14rem),
        $bg-header-control-color;
    border: 1px solid rgba($border-color, .24);
    box-shadow: inset 0 1px 0 rgba($font-label-color, .1), 0 .06rem .14rem rgba($bg-shell-color, .18);
}

.pages-header .area_left .down_box .down_img {
    background: linear-gradient(180deg, rgba($bg-shell-color, .96) 0%, rgba($bg-popup-color, .98) 100%);
    border: 1px solid rgba($border-color, .14);
    box-shadow: inset 0 1px 0 rgba($font-title-color, .04);
}

.pages-header .area_left .down_box .down_info > div:first-child {
    color: $font-title-color;
}

.pages-header .area_left .down_box .down_info > div:last-child {
    color: $font-sub-color;
}

.pages-header .search_btn {
    color: $font-title-color;
    background:
        radial-gradient(circle at 12% 0, rgba($border-active-color, .14) 0, rgba($border-active-color, 0) 30%),
        linear-gradient(180deg, rgba($font-label-color, .08) 0%, rgba($font-label-color, 0) .14rem),
        $bg-header-control-color;
    border: 1px solid $border-shadow-color;
}

.pages-header .user_login .sign_up {
    color: $font-title-color;
    background: $bg-header-button-color;
    border: 1px solid rgba($border-active-color, .42);
    box-shadow:
        inset 0 1px 0 rgba($font-title-color, .28),
        0 0 .2rem rgba($font-theme-color, .2),
        0 .06rem .14rem rgba($bg-shell-color, .14);
}

.pages-header .user_login .login,
.pages-header .user_info_pc,
.pages-header .Notification {
    background:
        radial-gradient(circle at 16% 0, rgba($font-theme-color, .15) 0, rgba($font-theme-color, 0) 28%),
        $bg-header-control-color;
    border: 1px solid rgba($border-color, .24);
    box-shadow:
        inset 0 1px 0 rgba($font-title-color, .08),
        0 .05rem .12rem rgba($bg-shell-color, .16);
}

.pages-header .user_login .login:hover,
.pages-header .user_info_pc:hover,
.pages-header .Notification:hover {
    border-color: rgba($border-active-color, .34);
    box-shadow:
        inset 0 1px 0 rgba($font-title-color, .1),
        0 0 .18rem rgba($font-theme-color, .12),
        0 .05rem .12rem rgba($bg-shell-color, .16);
}

.pages-header .Notification > i,
.pages-header .search_btn .iconfont,
.pages-header .user_info .icon-shuaxin,
.pages-header .user_info_pc .u-info > div:first-child,
.pages-header .user_info_pc .u-arrow {
    color: $font-title-color;
}

.pages-header .user_info_pc .u-info > div:last-child,
.pages-header .search_btn .txt {
    color: $font-sub-color;
}

.pages-header .user_login .login {
    color: $font-color;
}

@media screen and (max-width: 767px) {
    .pages-header .area_left .icon_toggle {
        width: .56rem !important;
        height: .56rem !important;
        padding: .1rem !important;
        box-sizing: border-box;
    }

    .pages-header {
        padding-left: 0 !important;
        justify-content: space-between;
    }

    .pages-header .area_left {
        left: .12rem !important;
        z-index: 4;
    }

    .pages-header .user_action {
        width: 100%;
        padding-left: 2.18rem;
        box-sizing: border-box;
    }

    .pages-header .user_action > div:first-child {
        display: none;
    }

    .pages-header .user_action > div:last-child {
        width: 100%;
        justify-content: flex-end;
        gap: .1rem;
        padding-right: 0;
        box-sizing: border-box;
    }

    .pages-header .user_info {
        min-width: 0 !important;
        width: auto !important;
        max-width: calc(100vw - 2.26rem) !important;
        height: .64rem !important;
        padding: .05rem .07rem .05rem .1rem !important;
        border-radius: .16rem !important;
        background:
            radial-gradient(circle at 16% 0, rgba($font-theme-color, .15) 0, rgba($font-theme-color, 0) 28%),
            $bg-header-control-color !important;
        border: 1px solid rgba($border-color, .24) !important;
        box-shadow:
            inset 0 1px 0 rgba($font-title-color, .08),
            0 .05rem .12rem rgba($bg-shell-color, .16) !important;
    }

    .pages-header .user_info .user_money {
        flex: 1;
        min-width: 0;
        margin-top: 0 !important;
        padding: 0 .01rem !important;
        color: $font-title-color !important;
        font-size: .23rem !important;
        line-height: .54rem !important;
        font-weight: 700 !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        background: transparent !important;
    }

    .pages-header .user_info .deposit {
        width: .54rem !important;
        min-width: .54rem !important;
        height: .54rem !important;
        line-height: .43rem !important;
        margin-left: .05rem !important;
        border-radius: .16rem !important;
        font-size: .38rem !important;
        background: $bg-header-button-color !important;
        color: $font-title-color !important;
        border: 1px solid rgba($border-active-color, .42) !important;
        box-shadow: inset 0 1px 0 rgba($font-title-color, .22), 0 .05rem .12rem rgba($bg-shell-color, .14) !important;
    }

    .pages-header .Notification {
        width: .6rem !important;
        height: .62rem !important;
        min-width: .6rem !important;
    }

    .pages-header .Notification > i {
        font-size: .24rem !important;
    }
}

</style>
